var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73804 15.571L15.4521 24.3565L16.4869 23.7356L15.866 24.7704L24.6515 36.4845L35.1082 5.11426L3.73804 15.571ZM15.6404 20.7052L10.1911 16.6182L30.3109 9.91156L23.6043 30.0314L19.5173 24.5821L25.3327 14.8898L15.6404 20.7052Z",
    fill: "#1B0076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73804 15.571L15.4521 24.3565L16.4869 23.7356L15.866 24.7704L24.6515 36.4845L35.1082 5.11426L3.73804 15.571ZM15.6404 20.7052L10.1911 16.6182L30.3109 9.91156L23.6043 30.0314L19.5173 24.5821L25.3327 14.8898L15.6404 20.7052Z",
    fill: "#1B0076"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4156 28.3026C8.65498 25.4214 5.49012 23.1354 3.10815 22.2906L4.16125 19.3213C7.19603 20.3976 10.7634 23.068 13.6904 26.1229C16.6035 29.1633 19.168 32.8815 19.8783 36.2321L16.7963 36.8855C16.2685 34.396 14.1901 31.1983 11.4156 28.3026Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationSent);
export default __webpack_public_path__ + "static/media/verification-sent.408325dc7e9c4141bac47c5f1268c37f.svg";
export { ForwardRef as ReactComponent };